import React, { Suspense } from 'react';

import './homepage.css';

import Header from '../../components/header/header';
import Hero from '../../components/hero/heropage';
const Aboutus = React.lazy(()=> import ('../../components/about-us/aboutus')) ;
const Booknow = React.lazy(()=> import ('../../components/book-now/booknow')) ;
const Whyus = React.lazy(()=> import ('../../components/why-us/whyus')) ;
const Footer = React.lazy(()=> import ('../../components/footer/footer')) ;
const Testimonials = React.lazy(()=> import ('../../components/testimonials/testimonials')) ;
const PlacesToVisit = React.lazy(()=> import ('../../components/places-to-visit/PlacesToVisit')) ;
const Gallery = React.lazy(()=> import ('../../components/gallery/gallery')) ;

const Homepage = () => {
    return (
        <div className="homepage">
            
            <Header />
            <Hero />
            <Suspense fallback={<div>Loading...</div>}>

            <Booknow />
            <Aboutus />
        
            <Whyus />
            <Gallery   />
            <PlacesToVisit />
            <Testimonials />
            <Footer />
      </Suspense>

       
        </div>
    );
}

export default Homepage;